import {
    Box,
    Button,
    Grid,
    makeStyles,
    TextField, Typography,
} from "@material-ui/core";
import {Close} from "@material-ui/icons";
import React from "react";
import {
    Controller,
    useFieldArray,
    useWatch
} from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import UploadImage from "../../UploadImage";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build";
import editorConfiguration
    from "../../../../util/EditorConfiguration";

const filmScreeningsDefaultValue = {
    img: "",
    desc: "",
};

const useStyles = makeStyles((theme) => ({
    filmScreeningsBlk: {
        background: "#FFFFFF",
        marginBottom: "20px",
    },
    filmScreeningsBlkHeader: {
        background: "#EDEEF0",
        borderLeft: "3px solid #9D3030",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "12px 13px",
    },
    filmScreeningsBlkBody: {
        border: "1px solid #CCCCCC",
        borderTop: "0px",
        padding: "20px 13px",
    },
    deleteBtn: {
        margin: "0",
        padding: "0",
        minWidth: "initial",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
}));

const FilmographyBlock = ({
                              control,
                              index,
                              classes,
                              disabled,
                              remove,
                              data,
                              dataTc,
                              setValue,
                              getValues,
                              defaultData
                          }) => {

    return (
        <>
            <Grid
                container
                className={classes.filmScreeningsBlkHeader}
                xs={12}
                alignItems="center"
                justify="space-between"
            >
                <span>Selected Filmography {index + 1}</span>
                {disabled || (
                    <Button className={classes.deleteBtn}
                            onClick={() => remove(index)}>
                        <Close style={{
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}/>
                    </Button>
                )}
            </Grid>
            <Box className={classes.filmScreeningsBlkBody}>
                <Grid container spacing={3}
                      direction="column">
                    <Grid container item xs={6}>
                        <UploadImage
                            name={`directors.directors[${index}].img`}
                            lang="en"
                            data={data}
                            embeddedName='img'
                            control={control}
                            Controller={Controller}
                            setValue={setValue}
                            getValues={getValues}
                            disabled={disabled}
                            uploadLabel="Upload Director Photo"
                            changeLabel="Change Director Photo"
                            uploadFolder="FILM"
                        />
                    </Grid>

                    <Box fontWeight={900}
                         fontSize={13} mb={1}
                         ml={2} width="100%">
                        <Typography variant="p">Description
                            (English)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            defaultValue={data?.desc}
                            name={`localizations.en.directors.directors[${index}].desc`}
                            control={control}
                            render={({
                                         field,
                                         fieldState: {error}
                                     }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        // editor.setData(initialValues.terms.valueEn);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Box fontWeight={900}
                         fontSize={13} mb={1}
                         ml={2} width="100%">
                        <Typography variant="p">Description
                            (Traditional Chinese)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            defaultValue={dataTc?.desc}
                            name={`localizations.tc.directors.directors[${index}].desc`}
                            control={control}
                            render={({
                                         field,
                                         fieldState: {error}
                                     }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        // editor.setData(initialValues.terms.valueEn);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    </Grid>
            </Box>
        </>
    );
};

export default function OtherSelectedFilmographySections(props) {
    const {
        control,
        setValue,
        getValues,
        disabled,
    } = props;

    const classes = useStyles();

    const {fields, append, remove} = useFieldArray({
            control,
            name: "localizations.en.directors.directors"
    })

    const {fieldsTc = fields, appendTc = append} = useFieldArray({
            control,
            name: "localizations.tc.directors.directors"
    })

    return (
        <>
            {fields.map((data, index) => (
                <div className={classes.filmScreeningsBlk}
                     key={data.id}>
                    <FilmographyBlock
                        {...{
                            control,
                            index,
                            classes,
                            disabled,
                            remove,
                            data,
                            dataTc: fieldsTc[index],
                            setValue,
                            getValues,
                        }}
                    />
                </div>
            ))}
            {disabled || (
                <Button
                    type="button"
                    onClick={() => {
                        append(filmScreeningsDefaultValue);
                        appendTc(filmScreeningsDefaultValue);
                    }}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon/>
                    Add Director
                </Button>
            )}
        </>
    );
}